import { useEffect, useState } from "react";
import { findSMV } from "../../api/ModelsApi";
import { LoadingOverlay, Stack } from "@mantine/core";

const SmvPreviewer = ({ model_id }) => {
  const [modelProfile, setModelProfile] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (model_id) {
      setLoading(true);
      findSMV(model_id)
        .then((response) => setModelProfile(response.data.model_profile))
        .finally(() => setLoading(false));
    }
  }, [model_id]);

  return (
    <Stack
      pos={"relative"}
      gap={"sm"}
      flex={1}
      w={"100%"}
      style={{
        overflow: "auto",
        borderRadius: 12,
        border: "1px solid #00000018",
      }}
      px={12}
      pt={12}
      mih={120}
    >
      <LoadingOverlay visible={loading} />

      {modelProfile?.voice_file_url && (
        <audio
          id="audio"
          controls
          src={modelProfile.voice_file_url}
          style={{ width: "100%" }}
        ></audio>
      )}
    </Stack>
  );
};

export default SmvPreviewer;
